"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateId = exports.mongoIdSchema = exports.MONGO_ID_PATTERN = void 0;
const joi_1 = __importDefault(require("joi"));
const schemaValidator_1 = require("./schemaValidator");
exports.MONGO_ID_PATTERN = /^[0-9a-f]{24}$/;
function mongoIdSchema() {
    return joi_1.default.string().pattern(exports.MONGO_ID_PATTERN);
}
exports.mongoIdSchema = mongoIdSchema;
function validateId(id) {
    const schema = joi_1.default.object().keys({
        id: mongoIdSchema().required(),
    });
    (0, schemaValidator_1.validateSchema)({ id }, schema);
}
exports.validateId = validateId;
